import React from 'react';
import c from 'classnames';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import Button from '../Button';
// @ts-ignore
const Dialog = _ref => {
  let {
    title,
    children,
    className,
    primaryButton,
    secondaryButton,
    wrapperRef,
    onCloseButtonClick,
    labelId,
    closeAriaLabel
  } = _ref;
  const {
    t
  } = useTranslation();
  const classNames = c('HVCDialog', className);
  return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "HVCDialog__backdrop"
  }), /*#__PURE__*/React.createElement("div", {
    className: "HVCDialog__container"
  }, /*#__PURE__*/React.createElement("div", {
    ref: wrapperRef,
    className: classNames,
    role: "dialog",
    "aria-labelledby": labelId,
    "aria-modal": "true"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    className: "h4",
    id: labelId
  }, title), children), /*#__PURE__*/React.createElement("div", {
    className: "HVCDialog__buttons"
  }, primaryButton != null && /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    variation: "center",
    onClick: primaryButton.onClick
  }, primaryButton.text), secondaryButton != null && /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    variation: "center",
    onClick: secondaryButton.onClick
  }, secondaryButton.text))), /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": closeAriaLabel || t('dialog_modal.close'),
    className: "small-close-button HVCDialog__closeModal",
    onClick: onCloseButtonClick
  }))), document.body);
};
export default Dialog;